export const live = {
  url: "https://www.dms.worldwebtrade.com",
  imgUrl: "https://www.dms.worldwebtrade.com/public/image/",
  productImg: "https://www.dms.worldwebtrade.com/public/image/products/",
  certificateImg: "https://www.dms.worldwebtrade.com/public/image/vcertificate/",
  companyUrl: "https://www.dms.worldwebtrade.com/public/image/company/",
  planUrl: "https://www.dms.worldwebtrade.com/public/image/membership/",
  gallery: "https://www.dms.worldwebtrade.com/public/image/gallery/",
  trendProduct: "https://www.dms.worldwebtrade.com/public/image/trendingproduct/",
  categorycard: "https://www.dms.worldwebtrade.com/public/image/categorycard/",
  bannerUrl: "https://www.dms.worldwebtrade.com/public/image/banners/",
  logosUrl: "https://www.dms.worldwebtrade.com/public/image/logos/",
  blogImg: "https://www.dms.worldwebtrade.com/public/image/blogs/",
}

export const local = {
  url: "http://localhost:8004",
  imgUrl: "http://localhost:8004/public/image/",
  productImg: "http://localhost:8004/public/image/products/",
  trendProduct: "http://localhost:8004/public/image/trendingproduct/",
  certificateImg: "http://localhost:8004/public/image/vcertificate/",
  gallery: "http://localhost:8004/public/image/gallery/",
  blogImg: "http://localhost:8004/public/image/blogs/",
  categorycard: "http://localhost:8004/public/image/categorycard/",
  companyUrl: "http://localhost:8004/public/image/company/",
  planUrl: "http://localhost:8004/public/image/membership/",
  bannerUrl: "http://localhost:8004/public/image/banners/",
  logosUrl: "http://localhost:8004/public/image/logos/",
}

export const api = process.env.NODE_ENV === "development" ? local : live
// export const api =  process.env.NODE_ENV === "development" ? local : live